import React from 'react'
import OnOrderQueue from './OnOrderQueue'

const OnOrder = () => {
  return (
    <div><OnOrderQueue/></div>
  )
}

export default OnOrder